// extracted by mini-css-extract-plugin
module.exports = {"select":"AddressManual_select__ZSeYp","colAddress":"AddressManual_colAddress__2KeGm"};